import { Autocomplete } from "@mui/material";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { memo, useCallback, useMemo } from "react";
import { createLogger } from "../../../helper/logger";
import "../../../index.css";

const DropdownCellRenderer = (props) => {
	const logger = useMemo(() => createLogger("DropdownCellRenderer"), []);
	logger.debug("Component rendering with props", props);

	const handleChange = useCallback(
		(event) => {
			if (props.node && props.colDef && props.colDef.field) {
				props.node.setDataValue(props.colDef.field, event.label);
			}
		},
		[props.node, props.colDef],
	);

	// Find the selected option object based on the ID
	const selectedOption = useMemo(() => {
		if (props.value == null || props.value === "") {
			return props.options?.[0] || null;
		}
		return (
			props.options?.find(
				(option) => option.Id === props.value || option.label === props.value,
			) || null
		);
	}, [props.value, props.options]);

	return (
		<Stack spacing={1} sx={{ width: 120, paddingTop: "5px" }}>
			<Autocomplete
				disableClearable
				id="module-dropdown"
				value={selectedOption}
				options={props.options}
				sx={{ width: 120, minHeight: 1 }}
				ListboxProps={{ style: { maxHeight: 250 } }}
				onChange={(_e, v) => handleChange(v)}
				isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
				renderOption={(props, option) => {
					return (
						<li {...props} key={option.Id}>
							<span
								className="autoComplete-list-review"
								style={{ fontSize: "0.875rem" }}
							>
								{option.label}
							</span>
						</li>
					);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="standard"
						size="small"
						InputProps={{
							...params.InputProps,
							inputProps: {
								...params.inputProps,
								style: { fontSize: "0.875rem" },
							},
						}}
					/>
				)}
			/>
		</Stack>
	);
};

export default memo(DropdownCellRenderer);
